/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * email_service
 * OpenAPI spec version: 0.1.0
 */

export type RefreshEmailEventOneOfOnethreeEvent =
  (typeof RefreshEmailEventOneOfOnethreeEvent)[keyof typeof RefreshEmailEventOneOfOnethreeEvent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefreshEmailEventOneOfOnethreeEvent = {
  backfill_progress: 'backfill_progress',
} as const;
